import React, { useState } from 'react'
import { withTranslationCustom } from 'lib/i18next'
import { ALLOWED_IMAGE_TYPES, MAX_IMAGE_UPLOAD_SIZE } from 'lib/constants'

import ExtendedDropzone from './ExtendedDropzone/ExtendedDropzone'
import Icon from 'components/Icon'
import LoadingIndicator from 'components/LoadingIndicator'

import './image-upload.pcss'
import ImageEdit from 'components/Image/ImageEdit/ImageEdit'

const ImageUpload = ({ t, allowMultiple, onUploadImage, uploading, text, maxSize, onImageSelected }) => {
    const [imageBlob, setImageBlob] = useState(null)
    const [selectedImage, setSelectedImage] = useState(null)

    const fileRejectedInfo = (invalidFileInfo) => {
        return (
            <>
                <Icon name="icon_alert_circle_red" size="xl" />
                <div>
                    {invalidFileInfo || t('invalidFile')}
                </div>
            </>
        )
    }

    const onSelectFile = file => {
        if (file) {
            // eslint-disable-next-line no-undef
            const reader = new FileReader()
            reader.addEventListener('load', () => {
                setImageBlob(reader.result)
                setSelectedImage(file)
                onImageSelected(true)
            })
            reader.readAsDataURL(file)
        }
    }

    return (
        <div>
            {(imageBlob && selectedImage) ? (
                <ImageEdit
                    isBlob={true}
                    image={imageBlob}
                    onCancel={() => {
                        setImageBlob(null)
                        setSelectedImage(null)
                        onImageSelected(null)
                    }}
                    onSave={(id, data) => {
                        onUploadImage(selectedImage, data)
                        setImageBlob(null)
                        setSelectedImage(null)
                        onImageSelected(null)
                    }}
                    mode="crop"
                />
            ) : (
                <ExtendedDropzone
                    className="image-upload"
                    allowedTypes={ALLOWED_IMAGE_TYPES}
                    maxSize={MAX_IMAGE_UPLOAD_SIZE}
                    multiple={allowMultiple}
                    onFileSelected={onSelectFile}
                    allowMultiple={true}
                >
                    {({ fileRejections }) => {
                        const content = uploading ? (
                            <LoadingIndicator type="plain" />
                        ) : (
                            <>
                                <Icon name="icon_plus" size="l" />
                                <div>{text || t('imageUpload:addImage')}</div>
                            </>
                        )

                        let contentError
                        if (fileRejections.length > 0) {
                            const fileTypeIsInvalid = fileRejections.some(file => !(file.type in ALLOWED_IMAGE_TYPES))
                            const fileIsTooLarge = fileRejections.some(file => file.size > maxSize)

                            const invalidFileInfo =
                                (fileTypeIsInvalid && t('invalidFileType')) ||
                                (fileIsTooLarge && t('fileSizeExceeded')) ||
                                null

                            contentError = fileRejectedInfo(invalidFileInfo)
                        }

                        return (
                            <div className="image-upload__dropzone-content">
                                {contentError}
                                {content}
                            </div>
                        )
                    }}
                </ExtendedDropzone>
            )}
        </div>
    )
}

export default withTranslationCustom('imageUpload')(ImageUpload)
